module.exports = __webpack_public_path__ + "img/icon_mission.c72762de.png";